export default __webpack_public_path__ + "static/media/logo.b33d7310.svg";